import { OtsStaffOrderStatus } from '../types';

export const OTS_STAFF_ORDER_STATUSES: readonly OtsStaffOrderStatus[] = ['new', 'preparing', 'ready', 'done'];
